import { EPaymentStatus } from "@/enums";
import { ICardInfo, IPaymentTransaction } from "@/interfaces";
import { assureType } from "@/utils";

export const CardMapper = (data: any): ICardInfo | null => {
    try {
        const card: ICardInfo = {
            id: data.id,
            card_last_digits: data.last_digits
        }
        return card
    } catch (error) {
        console.error('PaymentMappers.CardMapper', error, JSON.stringify(data))
        return null
    }
}
export const CardArrayMapper = (cards: any[]): ICardInfo[] => {
    try {
        if (!cards) {
            return []
        }
        return cards.map(elem => CardMapper(elem)).filter(assureType)
    } catch (error) {
        console.error('PaymentMappers.CardArrayMapper', error, JSON.stringify(cards))
        return []
    }
}
export const AddBalanceResponseMapper = (data: any): string => {
    return data?.id || ''
}
export const PaymentTransactionResponseMapper = (data: any): IPaymentTransaction => {
    return {
        id: data.id,
        qrcode_image: data.qrcode_image,
        pix_code: data.pix_code,
        value: data.value,
        status: {
            value: data.status,
            formatted: getPaymentStatus(data.status)
        }
    }
}

export const getPaymentStatus = (st: string): string => {
    switch (st) {
        case EPaymentStatus.canceled:
            return 'Cancelado'
        case EPaymentStatus.failed:
            return 'Falha no pagamento'
        case EPaymentStatus.paid:
            return 'Pago'
        case EPaymentStatus.pending:
            return 'Pagamento pendente'
        default: return 'N/A'
    }
}

